/*
 * mutations.js
 *
 * Description: Holds global Mutations (for store).
 *
 * This file is part of: "http://apps.sundair.com/", "SunCrew2"
 * Copyright ,2020 Sundair GmbH
 * Contact:  http://www.sundair.com/
 * @author Learek <michael.broeker@sundair.com>
 *
 */
// demo
export const updateValue = (state, payload) => {
    state.value = payload;
};
